// extracted by mini-css-extract-plugin
export default {"conteiner":"CartProducts_conteiner__YlRGO"};